import React from "react"
import ReactDOM from "react-dom"
import "./index.css"
import "./scripts/backgroundParallax"
import { Landing } from "./views/Landing"
import { Navigation } from "./components/Navigation"

import {
    BrowserRouter as Router,
    Switch,
    Route,
} from "react-router-dom"

const LazyDiscord = React.lazy(() => import("./views/Discord"))

const App: React.FC = () => {
    return (
        <Router>
            <Switch>
                <Route path="/discord" exact>
                    <React.Suspense fallback={<></>}>
                        <LazyDiscord />
                    </React.Suspense>
                </Route>
                <Route path="/" exact>
                    <Navigation />
                    <Landing />
                </Route>
            </Switch>
        </Router>
    )
}

ReactDOM.render(<App />, document.querySelector("#app"))
